import React from 'react';
import { useParams } from 'react-router-dom';
import { InvestorProfilesContainer } from './InvestorProfilesContainer';

export const InvestorProfiles = ({ datasource }) => {
    const { dfsClientId } = useParams();

    return (<InvestorProfilesContainer dfsClientId={dfsClientId} dataSource={datasource}/>);
};
